export const LOADING = "Loading...";
export const NO_PREDICTION_POSSIBLE = "No Prediction Possible";
export const SOURCE_IMAGES = "Source Image(s)";
